import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import api from '.';
import { CreatePutPreSignedUrlRequestDto } from '../dtos/requests/create-put-presigned-url.request.dto';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { CreatePutPreSignedUrlResponseDto } from '../dtos/responses/create-put-pre-signed-url.response.dto';

const createPreSignedUrl = (
  data: CreatePutPreSignedUrlRequestDto,
): Promise<BaseResponseDto<CreatePutPreSignedUrlResponseDto>> => {
  return api<BaseResponseDto<CreatePutPreSignedUrlResponseDto>, CreatePutPreSignedUrlRequestDto>(
    '/student/file/pre-signed/put',
    {
      method: 'POST',
      data,
    },
  );
};

/**
 *
 * @param options
 * @returns
 */
export const useCreatePreSignedUrl = (
  options?: Omit<
    UseMutationOptions<
      BaseResponseDto<CreatePutPreSignedUrlResponseDto>,
      unknown,
      CreatePutPreSignedUrlRequestDto
    >,
    'mutationFn'
  >,
) => {
  return useMutation<
    BaseResponseDto<CreatePutPreSignedUrlResponseDto>,
    unknown,
    CreatePutPreSignedUrlRequestDto
  >({
    mutationFn: createPreSignedUrl,
    ...options, // 전달받은 옵션을 병합
  });
};
